import { getEnvOnly } from "../../helpers/Meet";

export default {
  view: "TurnChecker",
  HorarioOutContinue: false,
  // autenticacion
  charging: false,
  servicioSelected: null,
  validationErrors: [],
  client: null,
  service: "",
  errorValidationTemporizer: null,
  explanation: true,
  servicesAvailable: [
    {
      label: "Exámenes diagnósticos",
      code_name: "examenes_diagnosticos",
      code: 1
    },
    {
      label: "Procedimientos quirúrgicos",
      code_name: "procedimientos_quirurgicos",
      code: 2
    },
    {
      label: "Otros servicios",
      code_name: "otros_servicios",
      code: 3
    }
  ],
  tipide: [
    // { value: null, text: "Seleccione una opción" },
    { value: "CC", text: "Cédula de Ciudadanía" },
    { value: "TI", text: "Tarjeta Identidad" },
    { value: "RC", text: "Registro Civil" },
    { value: "CE", text: "Cédula de Extranjería" },
    { value: "NU", text: "Número Único de Identificación" },
    { value: "PA", text: "Pasaporte" },
    { value: "AS", text: "Adulto Sin Identificación" },
    { value: "CD", text: "Carné Diplomático" },
    { value: "CN", text: "Certificado de Nacido Vivo" },
    { value: "CO", text: "Código" },
    { value: "IN", text: "N.I.T. NATURAL" },
    { value: "MS", text: "Menor Sin Identificación" },
    { value: "NI", text: "N.I.T." },
    { value: "PD", text: "Pasaporte Diplomático" },
    { value: "PE", text: "Permanencia Especial" },
    { value: "RM", text: "Registro Médico" },
    { value: "TE", text: "Tarjeta de Extranjería" }
  ],

  // documents
  files: [],
  colmedicaRequest: null,

  // B64 - enviado a bsix
  b64final: {
    ti: "",
    nu: "",
    ma: "",
    na: "",
    ap: "",
    tr: getEnvOnly().VUE_APP_DEBMEDIA_DEFAULT_TRAMITE,
    so: "",
    fu: "ad",
    em: "",
    ce: "",
    to: "",
    su: getEnvOnly().VUE_APP_DEBMEDIA_DEFAULT_BRANCH
  }
};
